import { render } from "./NewUploadTemplate.vue?vue&type=template&id=1b3316d4"
import script from "./NewUploadTemplate.vue?vue&type=script&lang=js"
export * from "./NewUploadTemplate.vue?vue&type=script&lang=js"

import "./NewUploadTemplate.vue?vue&type=style&index=0&id=1b3316d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__